import { useState } from 'react';

import useTranslations from '@/i18n/useTranslations';
import GoBackButton from '@/shared-components/buttons/components/GoBackButton';

import '../../artist-help/profile/styles.css';

export default function ProfileGalleryHelpArtistsPage() {
  const t = useTranslations('galleries_help.artists');
  const [openSections, setOpenSections] = useState({
    overview: false,
    dynamicInventoryStatus: false,
    createEditProfiles: false,
    permissions: false,
    artistAiProfile: false,
    whatArtistsCanDo: false,
    workingTogether: false,
  });

  function toggleSection(sectionKey) {
    setOpenSections((previous) => ({
      ...previous,
      [sectionKey]: !previous[sectionKey],
    }));
  }

  return (
    <section className="artist-help-category gallery-help-category">
      <header className="artist-help-category__header gallery-help-category__header">
        <GoBackButton alternativeRoute="/profile/gallery-help" />
        <h1>{t('title')}</h1>
      </header>

      <div className="artist-help-category__body gallery-help-category__body">
        <section className="artist-help-category__card artist-help-category__accordion gallery-help-category__card gallery-help-category__accordion">
          <button
            type="button"
            className="artist-help-category__accordion-trigger gallery-help-category__accordion-trigger"
            onClick={() => toggleSection('overview')}
            aria-expanded={openSections.overview}
          >
            <h2>{t('sections.overview.title')}</h2>
            <span
              className={`artist-help-category__accordion-icon gallery-help-category__accordion-icon ${openSections.overview ? 'open' : ''}`}
              aria-hidden
            />
          </button>

          {openSections.overview && (
            <div className="artist-help-category__accordion-content gallery-help-category__accordion-content">
              <p>{t('sections.overview.p1')}</p>
              <p>{t('sections.overview.p2')}</p>
              <p>{t('sections.overview.p3')}</p>
            </div>
          )}
        </section>

        <section className="artist-help-category__card artist-help-category__accordion gallery-help-category__card gallery-help-category__accordion">
          <button
            type="button"
            className="artist-help-category__accordion-trigger gallery-help-category__accordion-trigger"
            onClick={() => toggleSection('dynamicInventoryStatus')}
            aria-expanded={openSections.dynamicInventoryStatus}
          >
            <h2>{t('sections.dynamic_inventory_status.title')}</h2>
            <span
              className={`artist-help-category__accordion-icon gallery-help-category__accordion-icon ${openSections.dynamicInventoryStatus ? 'open' : ''}`}
              aria-hidden
            />
          </button>

          {openSections.dynamicInventoryStatus && (
            <div className="artist-help-category__accordion-content gallery-help-category__accordion-content">
              <p>{t('sections.dynamic_inventory_status.intro')}</p>

              <div className="artist-help-category__stack gallery-help-category__stack">
                <h3>{t('sections.dynamic_inventory_status.work_of_artist.title')}</h3>
                <p>{t('sections.dynamic_inventory_status.work_of_artist.p1')}</p>
              </div>

              <div className="artist-help-category__stack gallery-help-category__stack">
                <h3>{t('sections.dynamic_inventory_status.gallery_owned.title')}</h3>
                <p>{t('sections.dynamic_inventory_status.gallery_owned.p1')}</p>
                <p>{t('sections.dynamic_inventory_status.gallery_owned.p2')}</p>
                <p>{t('sections.dynamic_inventory_status.gallery_owned.p3')}</p>
              </div>
            </div>
          )}
        </section>

        <section className="artist-help-category__card artist-help-category__accordion gallery-help-category__card gallery-help-category__accordion">
          <button
            type="button"
            className="artist-help-category__accordion-trigger gallery-help-category__accordion-trigger"
            onClick={() => toggleSection('createEditProfiles')}
            aria-expanded={openSections.createEditProfiles}
          >
            <h2>{t('sections.create_edit_profiles.title')}</h2>
            <span
              className={`artist-help-category__accordion-icon gallery-help-category__accordion-icon ${openSections.createEditProfiles ? 'open' : ''}`}
              aria-hidden
            />
          </button>

          {openSections.createEditProfiles && (
            <div className="artist-help-category__accordion-content gallery-help-category__accordion-content">
              <p>{t('sections.create_edit_profiles.p1')}</p>
              <p>{t('sections.create_edit_profiles.p2')}</p>
              <p>{t('sections.create_edit_profiles.p3')}</p>
            </div>
          )}
        </section>

        <section className="artist-help-category__card artist-help-category__accordion gallery-help-category__card gallery-help-category__accordion">
          <button
            type="button"
            className="artist-help-category__accordion-trigger gallery-help-category__accordion-trigger"
            onClick={() => toggleSection('permissions')}
            aria-expanded={openSections.permissions}
          >
            <h2>{t('sections.permissions.title')}</h2>
            <span
              className={`artist-help-category__accordion-icon gallery-help-category__accordion-icon ${openSections.permissions ? 'open' : ''}`}
              aria-hidden
            />
          </button>

          {openSections.permissions && (
            <div className="artist-help-category__accordion-content gallery-help-category__accordion-content">
              <p>{t('sections.permissions.p1')}</p>
              <p>{t('sections.permissions.p2')}</p>
              <p>{t('sections.permissions.p3')}</p>
              <p>{t('sections.permissions.p4')}</p>
              <p>{t('sections.permissions.p5')}</p>
              <p>{t('sections.permissions.p6')}</p>
              <p>{t('sections.permissions.p7')}</p>
            </div>
          )}
        </section>

        <section className="artist-help-category__card artist-help-category__accordion gallery-help-category__card gallery-help-category__accordion">
          <button
            type="button"
            className="artist-help-category__accordion-trigger gallery-help-category__accordion-trigger"
            onClick={() => toggleSection('artistAiProfile')}
            aria-expanded={openSections.artistAiProfile}
          >
            <h2>{t('sections.artist_ai_profile.title')}</h2>
            <span
              className={`artist-help-category__accordion-icon gallery-help-category__accordion-icon ${openSections.artistAiProfile ? 'open' : ''}`}
              aria-hidden
            />
          </button>

          {openSections.artistAiProfile && (
            <div className="artist-help-category__accordion-content gallery-help-category__accordion-content">
              <p>{t('sections.artist_ai_profile.p1')}</p>
              <p>{t('sections.artist_ai_profile.p2')}</p>
            </div>
          )}
        </section>

        <section className="artist-help-category__card artist-help-category__accordion gallery-help-category__card gallery-help-category__accordion">
          <button
            type="button"
            className="artist-help-category__accordion-trigger gallery-help-category__accordion-trigger"
            onClick={() => toggleSection('whatArtistsCanDo')}
            aria-expanded={openSections.whatArtistsCanDo}
          >
            <h2>{t('sections.what_artists_can_do.title')}</h2>
            <span
              className={`artist-help-category__accordion-icon gallery-help-category__accordion-icon ${openSections.whatArtistsCanDo ? 'open' : ''}`}
              aria-hidden
            />
          </button>

          {openSections.whatArtistsCanDo && (
            <div className="artist-help-category__accordion-content gallery-help-category__accordion-content">
              <p>{t('sections.what_artists_can_do.intro')}</p>
              <ul>
                <li>{t('sections.what_artists_can_do.list_1')}</li>
                <li>{t('sections.what_artists_can_do.list_2')}</li>
                <li>{t('sections.what_artists_can_do.list_3')}</li>
                <li>{t('sections.what_artists_can_do.list_4')}</li>
              </ul>
            </div>
          )}
        </section>

        <section className="artist-help-category__card artist-help-category__accordion gallery-help-category__card gallery-help-category__accordion">
          <button
            type="button"
            className="artist-help-category__accordion-trigger gallery-help-category__accordion-trigger"
            onClick={() => toggleSection('workingTogether')}
            aria-expanded={openSections.workingTogether}
          >
            <h2>{t('sections.working_together.title')}</h2>
            <span
              className={`artist-help-category__accordion-icon gallery-help-category__accordion-icon ${openSections.workingTogether ? 'open' : ''}`}
              aria-hidden
            />
          </button>

          {openSections.workingTogether && (
            <div className="artist-help-category__accordion-content gallery-help-category__accordion-content">
              <p>{t('sections.working_together.p1')}</p>
              <p>{t('sections.working_together.p2')}</p>
              <p>{t('sections.working_together.p3')}</p>
            </div>
          )}
        </section>
      </div>
    </section>
  );
}
